import type { CbiFrontendServiceContext } from "../../frontend/context/CbiFrontendServiceContext";
import type { CatalogDiscountCategoryRef } from "./CatalogDiscountCategoryRef";
import type { CatalogDiscountCategoryStaff } from "./CatalogDiscountCategoryStaff";
import type { CatalogDiscountDTOBase } from "./CatalogDiscountDTOBase";
import type { CatalogDiscountInstanceStaff } from "./CatalogDiscountInstanceStaff";
import type { CatalogRef } from "./CatalogRef";
import type { CatalogStaff } from "./CatalogStaff";
import type { TrackedBase } from "./TrackedBase";

export class CatalogDiscountStaff implements CatalogDiscountDTOBase, TrackedBase {
  constructor(public readonly discountId: number, public readonly catalogId: CatalogStaff | null, public readonly discountName: string, public readonly alertOnClose: boolean | null, public readonly createdOn: Date | null, public readonly createdBy: string | null, public readonly updatedOn: Date | null, public readonly updatedBy: string | null, public readonly categoryId: CatalogDiscountCategoryStaff | null, public readonly discountInstances: Array<CatalogDiscountInstanceStaff> | null, public readonly catalogIdTargetIds: CatalogRef | null, public readonly categoryIdTargetIds: CatalogDiscountCategoryRef | null) {
    this.cbiServiceContext = null;
    this.catalogIdLoaded = this.catalogId != null;
    this.catalogIdCached = this.catalogId;
    this.categoryIdLoaded = this.categoryId != null;
    this.categoryIdCached = this.categoryId;
    this.discountInstancesLoaded = this.discountInstances != null;
    this.discountInstancesCached = this.discountInstances;
  }
  cbiServiceContext: CbiFrontendServiceContext | null;
  private catalogIdLoaded: boolean;
  private catalogIdCached: CatalogStaff | null;
  private categoryIdLoaded: boolean;
  private categoryIdCached: CatalogDiscountCategoryStaff | null;
  private discountInstancesLoaded: boolean;
  private discountInstancesCached: Array<CatalogDiscountInstanceStaff> | null;
  async catalogIdLazy(): Promise<CatalogStaff | null> {
    if (!this.catalogIdLoaded) {
      this.catalogIdCached = await (this.catalogIdTargetIds != null ? this.cbiServiceContext!.catalogService().getCatalogStaff(this.catalogIdTargetIds.assignId) : Promise.resolve(null));
      this.catalogIdLoaded = true;
    }
    return this.catalogIdCached;
  }
  async categoryIdLazy(): Promise<CatalogDiscountCategoryStaff | null> {
    if (!this.categoryIdLoaded) {
      this.categoryIdCached = await (this.categoryIdTargetIds != null ? this.cbiServiceContext!.discountService().getCatalogDiscountCategoryStaff(this.categoryIdTargetIds.categoryId) : Promise.resolve(null));
      this.categoryIdLoaded = true;
    }
    return this.categoryIdCached;
  }
  async discountInstancesLazy(): Promise<Array<CatalogDiscountInstanceStaff>> {
    if (!this.discountInstancesLoaded) {
      this.discountInstancesCached = await this.cbiServiceContext!.discountService().getCatalogDiscountStaffDiscountInstances(this.discountId);
      this.discountInstancesLoaded = true;
    }
    return this.discountInstancesCached!;
  }
}
